import { CONTENT_WIDTH } from "@/enums";
import { Button, Col } from "antd";
import { bool, func, string } from "prop-types";

const ApproveAndRejectActions = ({
  disableActions,
  isApprovalLoading,
  isRejectedLoading,
  approveButtonText,
  approveButtonOnClick,
  rejectButtonOnClick,
  rejectButtonText,
}) => (
  <>
    <Col
      xxl={CONTENT_WIDTH.oneSixth}
      lg={CONTENT_WIDTH.oneQuarter}
      sm={CONTENT_WIDTH.half}
      xs={CONTENT_WIDTH.max}
    >
      <Button
        data-test-id="view-intake-approve-button"
        key={"1"}
        type="primary"
        loading={isApprovalLoading}
        disabled={isRejectedLoading || disableActions}
        onClick={approveButtonOnClick}
        block
      >
        {approveButtonText}
      </Button>
    </Col>
    <Col
      xxl={CONTENT_WIDTH.oneSixth}
      lg={CONTENT_WIDTH.oneQuarter}
      sm={CONTENT_WIDTH.half}
      xs={CONTENT_WIDTH.max}
    >
      <Button
        data-test-id="view-intake-reject-button"
        key={"2"}
        type="primary"
        loading={isRejectedLoading}
        disabled={isApprovalLoading || disableActions}
        onClick={rejectButtonOnClick}
        block
      >
        {rejectButtonText}
      </Button>
    </Col>
  </>
);

ApproveAndRejectActions.propTypes = {
  approveButtonText: string.isRequired,
  approveButtonOnClick: func.isRequired,
  rejectButtonOnClick: func.isRequired,
  rejectButtonText: string.isRequired,
  isApprovalLoading: bool.isRequired,
  isRejectedLoading: bool.isRequired,
  disableActions: bool.isRequired,
};

export { ApproveAndRejectActions };
